import { useState, useRef } from "react";
import { initTranspaletaFree, ITEMS_TRANSPALETA_CRITICOS_FREE, ITEMS_TRANSPALETA_ELECTRICA_FREE } from '../constants/freeFormConfig';
import { Inp, Sel, RG, ChecklistSeccion, FirmaCanvas, TranspaletaIconSVG, CampoPDF, ChecklistSeccionPDF, FilaEstadoPDF, FirmaPDF, ModalCuotaFree } from './ui/FormControls';
import { generarPdfFree, nombreArchivoPdfFree } from '../services/pdf-free';
import { useDescargaFree } from '../hooks/useDescargaFree';

// ── PLAN FREE: Checklist Transpaleta (Manual/Eléctrica) ───────────
export const FreeTranspaletaForm = () => {
  const [form, setForm] = useState(initTranspaletaFree());
  const [completado, setCompletado] = useState(false);
  const [pdfDoc, setPdfDoc] = useState(null);
  const printRef = useRef(null);
  const { intentarDescarga, generando, bloqueo, cerrarBloqueo } = useDescargaFree();
  const listo = form.nombre.trim() && form.modelo.trim() && form.firma;
  const validadoPorTexto = `Validado por: ${form.nombre || "—"} · ${new Date().toLocaleDateString("es-ES")} ${new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}`;

  const finalizar = () => intentarDescarga(async () => {
    const doc = await generarPdfFree(printRef.current);
    setPdfDoc(doc);
    setCompletado(true);
  });

  const descargar = () => pdfDoc?.save(nombreArchivoPdfFree("checklist_transpaleta", form.modelo));

  return (
    <>
      {completado ? (
        <div className="bg-white rounded-xl shadow p-4 space-y-4 text-center">
          <p className="text-2xl">✅</p>
          <h2 className="font-bold text-gray-800">Checklist completado</h2>
          <p className="text-sm text-gray-500">{validadoPorTexto}</p>
          <button onClick={descargar} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 transition-all">Descargar PDF</button>
          <button onClick={() => setCompletado(false)} className="text-xs text-gray-400 hover:text-gray-600">← Volver al checklist</button>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow p-4 space-y-4">
          <h2 className="font-bold text-gray-800 border-b pb-2 flex items-center gap-2"><TranspaletaIconSVG size={20} /> Checklist Transpaleta</h2>
          <div className="grid grid-cols-2 gap-3">
            <Inp label="Nombre *" value={form.nombre} onChange={v => setForm(f => ({ ...f, nombre: v }))} placeholder="Nombre completo" />
            <Inp label="Modelo / Identificación *" value={form.modelo} onChange={v => setForm(f => ({ ...f, modelo: v }))} placeholder="Ej: TM-01" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Sel label="Tipo" value={form.tipo} onChange={v => setForm(f => ({ ...f, tipo: v }))} options={["Manual", "Eléctrica"]} />
            <Inp label="Fecha" type="date" value={form.fecha} onChange={v => setForm(f => ({ ...f, fecha: v }))} />
          </div>

          <ChecklistSeccion titulo="Controles críticos" color="bg-red-50 text-red-700" items={ITEMS_TRANSPALETA_CRITICOS_FREE} value={form.criticos} onChange={criticos => setForm(f => ({ ...f, criticos }))} />

          {form.tipo === "Eléctrica" && (
            <ChecklistSeccion titulo="Controles eléctrica" color="bg-orange-50 text-orange-700" items={ITEMS_TRANSPALETA_ELECTRICA_FREE} value={form.electrica} onChange={electrica => setForm(f => ({ ...f, electrica }))} />
          )}

          <div className="border rounded-lg overflow-hidden">
            <div className="bg-gray-100 px-3 py-2"><p className="text-xs font-bold text-gray-700 uppercase">Comprobación de uso</p></div>
            <div className="flex items-center justify-between px-3 py-2 gap-2">
              <span className="text-sm text-gray-700 flex-1">Limpieza incorrecta</span>
              <RG value={form.usoLimpieza} onChange={v => setForm(f => ({ ...f, usoLimpieza: v }))} opts={["Correcto", "Incorrecto", "No evaluado"]} />
            </div>
          </div>

          <div>
            <label className="text-xs font-semibold text-gray-600 uppercase">Observaciones</label>
            <textarea className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" rows={3} value={form.observaciones} onChange={e => setForm(f => ({ ...f, observaciones: e.target.value }))} />
          </div>

          <FirmaCanvas onChange={firma => setForm(f => ({ ...f, firma }))} />
          {form.firma && <p className="text-xs text-gray-500 text-center">{validadoPorTexto}</p>}

          <button onClick={finalizar} disabled={!listo || generando} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-all">
            {generando ? "Generando PDF..." : "Finalizar checklist →"}
          </button>
        </div>
      )}

      {/* Vista oculta de solo lectura, usada únicamente para generar el PDF */}
      <div ref={printRef} style={{ position: "absolute", left: "-9999px", top: 0, width: 800 }} className="bg-white p-6 space-y-4">
        <h2 className="font-bold text-gray-800 border-b pb-2 flex items-center gap-2"><TranspaletaIconSVG size={20} /> Checklist Transpaleta</h2>
        <div className="grid grid-cols-2 gap-3">
          <CampoPDF label="Nombre" value={form.nombre} />
          <CampoPDF label="Modelo / Identificación" value={form.modelo} />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <CampoPDF label="Tipo" value={form.tipo} />
          <CampoPDF label="Fecha" value={form.fecha} />
        </div>
        <ChecklistSeccionPDF titulo="Controles críticos" color="bg-red-50 text-red-700" items={ITEMS_TRANSPALETA_CRITICOS_FREE} value={form.criticos} />
        {form.tipo === "Eléctrica" && (
          <ChecklistSeccionPDF titulo="Controles eléctrica" color="bg-orange-50 text-orange-700" items={ITEMS_TRANSPALETA_ELECTRICA_FREE} value={form.electrica} />
        )}
        <div className="border rounded-lg overflow-hidden">
          <div className="bg-gray-100 px-3 py-2"><p className="text-xs font-bold text-gray-700 uppercase">Comprobación de uso</p></div>
          <FilaEstadoPDF label="Limpieza incorrecta" estado={form.usoLimpieza} />
        </div>
        <CampoPDF label="Observaciones" value={form.observaciones} />
        <FirmaPDF dataUrl={form.firma} />
        <p className="text-xs text-gray-500 text-center">{validadoPorTexto}</p>
      </div>

      <ModalCuotaFree bloqueo={bloqueo} onClose={cerrarBloqueo} />
    </>
  );
};
